import { useEffect, useState } from "react";
import { GROWTH_REQUESTS } from "../../../config/Endpoints.js";
import { getAuthToken } from "../../../utils/Storage.js";
import { getApi } from "../../utils/api.ts";
import RequestActivity, { type ActivityNote } from "./request-activity.tsx";
import styles from "./request-detail.module.css";

type RequestNote = ActivityNote & { requestId: number };

export default function RequestConversation({ requestId, employeeId, ownerId }: { requestId: number; employeeId: number; ownerId: number | null }) {
  const [notes, setNotes] = useState<RequestNote[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true); setError(""); setNotes([]);
    async function load() {
      try {
        const response = await getApi<RequestNote[]>(`${GROWTH_REQUESTS}/${requestId}/notes`, getAuthToken("accessToken"), "json", controller.signal);
        if (!Array.isArray(response.data)) throw new Error("Could not load updates and conversation.");
        const visible = response.data.filter((note) => note.requestId === requestId && note.noteType !== "INTERNAL_NOTE");
        visible.sort((a, b) => (a.updatedAt || "").localeCompare(b.updatedAt || "") || a.id - b.id);
        if (!controller.signal.aborted) setNotes(visible);
      } catch (cause) { if (!controller.signal.aborted) setError(cause instanceof Error ? cause.message : "Could not load updates and conversation."); }
      finally { if (!controller.signal.aborted) setLoading(false); }
    }
    void load();
    return () => controller.abort();
  }, [requestId, attempt]);

  return <RequestActivity
    audience="employee"
    className={`${styles.card} ${styles.conversation}`}
    notes={notes}
    loading={loading}
    error={error}
    onRetry={() => setAttempt((value) => value + 1)}
    employeeId={employeeId}
    ownerId={ownerId}
  />;
}
